/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;

      this.current = Number(this.dataset.current);
      this.total = Number(this.dataset.total);

      this.i = this.current; // <-- empezar desde la página real

      this.shownCountEl = document.querySelector('.shown-count');
      this.totalCountEl = document.querySelector('.total-count');
      this.shown = this.grid.querySelectorAll('.column').length;

    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this;

      if (base.getAttribute('loading')) return;

      // ⬆️ avanzar página ANTES del fetch
      base.i++;

      // 🚫 si ya no hay más páginas, cortar
      if (base.i > base.total) {
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      const url =
        document.location.pathname +
        base.addUrlParam(document.location.search, 'page');

      base.setAttribute('loading', true);

      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          base.renderProducts(responseText, url);

          base.current = base.i;

          // ✅ ocultar botón EXACTAMENTE en la última página
          if (base.current >= base.total && base.button) {
            base.button.classList.add('visually-hidden');
          }

          dispatchCustomEvent('pagination:page-changed', { url });
        });
    }



    renderProducts(html, url) {
      let base = this,
        grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');

      if (!grid_to_replace) {
        if (base.observer) base.observer.unobserve(base);
        base.removeAttribute('loading');
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      let products = grid_to_replace.querySelectorAll('.column');

      // 🔥 FIX IMPORTANTE: si ya no vienen productos → detener y ocultar botón
      if (!products.length) {
        if (base.observer) base.observer.unobserve(base);
        base.removeAttribute('loading');
        if (base.button) base.button.classList.add('visually-hidden');
        return;
      }

      for (var i = 0; i < products.length; i++) {
        this.grid.appendChild(products[i]);
        products[i].querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      this.shown += products.length;

      // 🔒 nunca mostrar más que el total real
      const total = Number(this.totalCountEl?.textContent || 0);

      if (total && this.shown > total) {
        this.shown = total;
      }

      if (this.shownCountEl) {
        this.shownCountEl.textContent = this.shown;
      }
      
      if (this.animations_enabled) {
        gsap.set(products, {
          opacity: 0,
          y: 30
        });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    }
  }
  customElements.define('pagination-theme', Pagination);
}